import React, { useState } from 'react';
import { UserPlus, Link2, Check, Copy } from 'lucide-react';

export function LimitModal({ onClose, navigate }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in" data-testid="limit-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-sm rounded-2xl p-8 border animate-scale-in bg-surface border-line"
        style={{ boxShadow: '0 25px 50px -12px rgba(0,0,0,0.8)' }}>
        <div className="text-center">
          <div className="w-12 h-12 mx-auto mb-5 rounded-full flex items-center justify-center bg-emerald-500/10 border border-emerald-500/25">
            <UserPlus className="w-5 h-5 text-emerald-500" strokeWidth={1.5} />
          </div>
          <h3 className="text-lg font-heading font-bold mb-2 text-content tracking-tight">
            Free messages used
          </h3>
          <p className="text-sm mb-6 text-content-2 font-sora leading-relaxed">
            Create a free account to continue chatting with OpenSov AI.
          </p>
          <button onClick={() => navigate('/auth')}
            className="w-full py-3 rounded-xl bg-btn text-btn-foreground font-sora font-semibold text-sm hover:opacity-90 transition-all active:scale-[0.98]"
            data-testid="limit-signup-btn">
            Create Free Account
          </button>
          <button onClick={onClose}
            className="w-full py-2.5 mt-2 rounded-xl text-sm transition-colors text-content-3 hover:text-content-2 font-sora"
            data-testid="limit-close-btn">
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}

export function ShareModal({ link, onClose }) {
  const [copied, setCopied] = useState(false);
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const input = document.createElement('input');
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in" data-testid="share-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-2xl p-8 border animate-scale-in bg-surface border-line"
        style={{ boxShadow: '0 25px 50px -12px rgba(0,0,0,0.8)' }}>
        <div className="text-center">
          <div className="w-12 h-12 mx-auto mb-5 rounded-full flex items-center justify-center bg-emerald-500/10 border border-emerald-500/25">
            <Link2 className="w-5 h-5 text-emerald-500" strokeWidth={1.5} />
          </div>
          <h3 className="text-lg font-heading font-bold mb-2 text-content tracking-tight">
            Share Conversation
          </h3>
          <p className="text-sm mb-5 text-content-2 font-sora">
            Anyone with this link can view this conversation.
          </p>
          <div className="flex items-center gap-2 p-2 rounded-xl mb-5 bg-overlay border border-line">
            <input type="text" readOnly value={link}
              className="flex-1 bg-transparent text-[13px] outline-none px-2 truncate text-content-2 font-sora"
              data-testid="share-link-input" />
            <button onClick={copyLink}
              className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all active:scale-95 font-sora
                ${copied ? 'bg-green-500/15 text-green-400' : 'bg-overlay text-content-2 hover:bg-overlay-hover'}`}
              data-testid="copy-link-btn">
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" strokeWidth={1.5} />}
              {copied ? 'Copied' : 'Copy'}
            </button>
          </div>
          <button onClick={onClose}
            className="w-full py-2.5 rounded-xl text-sm transition-colors text-content-3 hover:text-content-2 font-sora"
            data-testid="share-close-btn">
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
